export const localeOptions = [
    { id: 'ru', name: 'Русский' },
    // { id: 'kz', name: 'Казахский' },
    { id: 'az', name: 'Азербайджанский' },
    // { id: 'uz', name: 'Узбекский' },
    { id: 'hy', name: 'Армянский' },
    { id: 'ka', name: 'Georgian' },
    { id: 'en', name: 'English' },
    { id: 'pt', name: 'Português' },
    { id: 'es', name: 'Español' },
    { id: 'ar', name: 'Arabic' },
    { id: 'he', name: 'Hebrew' },
    { id: 'nl', name: 'Dutch' },
];
